module.exports = __webpack_public_path__ + "img/icon-trophy.c72ccf95.svg";